import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Rating(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="RatingIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#CDC1E5" />
        <path
          d="M14.0001 5.66699C9.40008 5.66699 5.66675 9.40033 5.66675 14.0003C5.66675 18.6003 9.40008 22.3337 14.0001 22.3337C18.6001 22.3337 22.3334 18.6003 22.3334 14.0003C22.3334 9.40033 18.6001 5.66699 14.0001 5.66699ZM14.0001 20.667C10.3167 20.667 7.33341 17.6837 7.33341 14.0003C7.33341 10.317 10.3167 7.33366 14.0001 7.33366C17.6834 7.33366 20.6667 10.317 20.6667 14.0003C20.6667 17.6837 17.6834 20.667 14.0001 20.667Z"
          fill="#6B5499"
        />
        <path
          d="M13.9999 18.1663C16.3011 18.1663 18.1666 16.3009 18.1666 13.9997C18.1666 11.6985 16.3011 9.83301 13.9999 9.83301C11.6987 9.83301 9.83325 11.6985 9.83325 13.9997C9.83325 16.3009 11.6987 18.1663 13.9999 18.1663Z"
          fill="#6B5499"
        />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Rating;
